<template>
  <div>
    <div ref="modelCourseTop" class="absolute target-top"></div>
    <div class="text-center mb-2 font-bold">{{ course.title }}</div>
    <div class="modal-content">
      <div v-if="course.images && course.images.length > 0" class="modal-detail">
        <img v-lazy="course.images[imageIndex]" class="course-image" />
        <div v-if="course.images.length >= 2" class="text-center">
          <span><a @click="prevImage" class="text-gray-600 text-sm" :class="imageIndex > 0 ? 'visible' : 'invisible'">＜ 前の画像</a></span>
          ({{ imageIndex + 1 }}/{{ course.images.length }})
          <span><a @click="nextImage" class="text-gray-600 text-sm" :class="imageIndex < course.images.length - 1 ? 'visible' : 'invisible'">次の画像 ＞</a></span>
        </div>
      </div>
      <p class="mt-2 mb-6 leading-tight" v-html="course.detail"></p>
    </div>
    <course-places :course="course" :createPlan="createPlan" @openMap="openMap" />
    <div :class="createPlan ? (isMobile() ? 'fixed bottom-0 left-0 right-0 mx-6 px-2 pb-4 bg-light_gray z-10 border-t-2' : 'fixed bottom-0 w-88 px-2 pb-4 bg-light_gray z-10 border-t-2') : 'mt-4'">
      <div v-if="!token" class="mb-1">
        <p>{{$t('tour_login_message')}}</p>
      </div>
      <a class="button-primary block button-icon icon-left" @click="createItem(course)" :class="token ? 'mt-2' : ''">
        <svg height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg" class="text-white"><path d="m734.333333 280.666667v2.666666h-2.666666c-.36819 0-.666667.298477-.666667.666667s.298477.666667.666667.666667h2.666666v2.666666c0 .36819.298477.666667.666667.666667s.666667-.298477.666667-.666667v-2.666666h2.666666c.36819 0 .666667-.298477.666667-.666667s-.298477-.666667-.666667-.666667h-2.666666v-2.666666c0-.36819-.298477-.666667-.666667-.666667s-.666667.298477-.666667.666667" transform="translate(-729 -278)"/></svg>
        <span>{{ $t('tour_create_plan_label') }}</span>
      </a>
    </div>
    <div class="mt-4">
      <div v-if="createPlan" :class="token ? 'mb-16' : 'mb-20'">
        <a @click="closeModal()" class="button-secondary block button-icon icon-left">
          <span>閉じる</span>
        </a>
      </div>
      <div v-else>
        <a @click="$emit('closeCourse')" class="button-secondary block button-icon icon-left">
          <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
          <span>モデルコース トップへ</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CoursePlaces from './CoursePlaces'
import Constants from '../../constants'

export default {
  name: 'CourseDetail',
  components: {
    CoursePlaces
  },
  props: {
    course: {
      type: Object,
      default: function () {
        return {
          id: null,
          title: null,
          detail: null,
          image: null
        }
      }
    },
    createPlan: {
      type: Boolean,
      required: false,
      default: true
    },
    closeModal: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters({
      token: 'user/getToken'
    }),
    datetime: {
      get () {
        return this.$store.getters['condition/getTime']
      },
      set (value) {
        this.$store.dispatch('condition/updateTime', value)
      }
    }
  },
  data () {
    return {
      imageIndex: 0
    }
  },
  methods: {
    openMap: function () {
      this.$emit('openMap')
    },
    prevImage: function () {
      this.imageIndex--
    },
    nextImage: function () {
      this.imageIndex++
    },
    createItem (course) {
      // GoogleAnalytics
      this.$gtag.event("コースからプラン作成", {
        course_name: this.course.title
      });
      const areaId = this.$store.getters['user/getAreaId']
      if (areaId == Constants.DEFAULT_AREA_ID){
        this.$router.push({ name: 'newPlan', query: { courseId: course.course_id }, params: { lang: this.$store.getters['user/getLang'] } })
      }else{
        this.$router.push({ name: 'newPlan', query: { courseId: course.course_id }, params: { lang: this.$store.getters['user/getLang'], areaId: areaId } })
      }
    },
    isMobile: function () {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("iphone") != -1 || userAgent.indexOf("android") != -1) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    course: function () {
      this.$refs['modelCourseTop'].scrollIntoView({ behavior: 'smooth'})
    }
  }
}
</script>
